export interface IConditionalBlockModel {
    col_name: string;
}

export class ConditionalBlockModel implements IConditionalBlockModel {
    col_name: string;
    fieldType: string;

    constructor(data:{} = undefined) {
        if(data) {
            this.col_name = data['col_name'] ? data['col_name'] : '';
            this.fieldType = data['fieldType'] ? data['fieldType'] : '';
        }
    }
}
